import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { User } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const Privacy: React.FC = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    if (user) {
      console.log('Current user ID:', user.id);
    }
  }, [user]);

  return (
    <div className="container mx-auto px-4 py-16 max-w-4xl">
      <h1 className="text-4xl font-bold mb-8">Privacy Policy</h1>
      
      <div className="prose prose-lg">
        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">1. Information Collection and Use</h2>
          <p>When you use WhenBald, we collect:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Photos you upload or take for hair loss progression previews</li>
            <li>Device and usage information</li>
            <li>Email address and location when provided</li>
          </ul>
          <p>Providing personal or business data (e-mail address, name, etc.) is entirely voluntary and used only for service improvement or communication.</p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">2. Data Protection and Security</h2>
          <p>We implement robust security measures:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Photos are processed instantly and not stored permanently</li>
            <li>Encrypted data transmission</li>
            <li>Routine security audits</li>
            <li>Protection from unauthorized access</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">3. Use of Information</h2>
          <p>Your information is used to:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Generate AI-powered hair loss previews</li>
            <li>Improve our algorithms and user experience</li>
            <li>Ensure service quality and support</li>
            <li>Send requested updates and information</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">4. Third-Party Links</h2>
          <p>
            WhenBald may include links to external websites. We do not control the content or policies of external sites and accept no liability for them. Please review their privacy practices if you visit those sites.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">5. Communication</h2>
          <p>
            We prohibit third parties from using published contact details for unsolicited marketing. Legal action may be taken against spammers or misuse of our contact details.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">6. Your Rights</h2>
          <p>You have the right to:</p>
          <ul className="list-disc pl-6 mb-4">
            <li>Access your personal data</li>
            <li>Request deletion of your data</li>
            <li>Opt out of data collection</li>
            <li>Correct inaccurate information</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-2xl font-semibold mb-4">7. Contact Us</h2>
          <p>For privacy-related questions or requests, contact us at:</p>
          <p>penri@penri.com</p>
        </section>

        <div className="mt-16 bg-gradient-to-r from-primary-50 to-white p-8 rounded-2xl shadow-sm">
          <div className="text-center">
            <h2 className="text-2xl font-semibold mb-4">Experience WhenBald Securely</h2>
            <p className="text-gray-600 mb-6">
              Your privacy is protected with our instant, secure processing—no photos are stored.
            </p>
            <button
              onClick={() => navigate('/')}
              className="bg-primary-600 text-white px-8 py-4 rounded-xl hover:bg-primary-700 transition-all transform hover:scale-105 inline-flex items-center gap-2"
            >
              <User size={20} />
              Try WhenBald Free
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
